import "./src/styles/tailwind.css"
import "./src/styles/markdown.css"

require("prism-themes/themes/prism-vs.css")

// Clean up any existing service workers from gatsby-plugin-offline
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for(let registration of registrations) {
        registration.unregister()
      }
    })
  }
}

// Prevent errors from missing service worker
export const onServiceWorkerUpdateReady = () => {
  // No-op to prevent errors
}

export const onServiceWorkerActive = () => {
  // No-op to prevent errors
}

// Track page views with Google Analytics
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
      anonymize_ip: true,
    })
  }
}
